import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";

function CookiePolicy() {
  return (
    <PolicyLayout
      title="Cookie and browser storage notice"
      intro="The storefront uses local browser storage to make the cart persist between pages and visits."
    >
      <section>
        <h2>The storage item</h2>
        <p>The key <code>cartItems</code> holds the product identifier, selected size or colour, and quantity for each basket line. It is functional storage read by this storefront in the browser; it does not by itself contain a delivery address or payment credential.</p>
      </section>

      <section>
        <h2>Duration and control</h2>
        <p>The value remains until cart lines are removed, the browser's site data is cleared, or the browser removes it under the user's settings. Disabling local storage can stop the cart from surviving a refresh, but the product and policy pages remain readable.</p>
      </section>

      <section>
        <h2>Hosted payment storage</h2>
        <p>Opening the hosted Stripe checkout leaves this storefront. Stripe may set security, fraud-prevention and session technologies needed to run that page. The controls and retention for those technologies are described in the notice available in the hosted environment.</p>
      </section>

      <section>
        <h2>Changes to browser technology</h2>
        <p>Any later introduction of non-essential measurement or advertising storage requires this notice and the relevant preference controls to be reviewed before activation. Personal-data handling connected with cart storage is explained in the <Link to="/privacy">Privacy policy</Link>.</p>
      </section>
    </PolicyLayout>
  );
}

export default CookiePolicy;
